import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=0b3ac99c&scoped=true"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"
import style0 from "./Call.vue?vue&type=style&index=0&id=0b3ac99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ac99c",
  null
  
)

export default component.exports